export default __webpack_public_path__ + "static/media/default.90aaa14577b9aca96ce17de95db42eb4.png";